import type { FaireCollectionEntity } from "../../entity_types/collection";

export const pbc_xryjygatkx: FaireCollectionEntity = {
  token: "pbc_xryjygatkx",
  type: "collection",
  name: "JB Petites",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6907c25d12a5fd8560fc7eba870a9baf37796907228a5542ced4c7c9aad28da1.jpeg",
  itemCount: 7,
  description:
    "Fully redesigned top block, with adjusted rise, inseam and proportional knee placement.",
  brandToken: "b_d5ug42njab",
  productTokens: [],
  meta: {
    source: "api",
    importedAt: "2026-08-11T00:35:14.961Z",
    importedBy: "entity-db-import-collections",
  },
};
